import { BruksklasserTommerTransport, BruksklasseTommerTransport, useRouteSettings, useRouteSettingsActions } from "../../stores/RouteSettingsStore";
import { SelectInput } from "../common/SelectInput";

export default function BruksklasseTommerTransportSettings() {
    const routeSettings = useRouteSettings();
    const { setRouteSettings } = useRouteSettingsActions();
    return(
        <>
            {routeSettings.routeType === "bruksklasseTommerTransport" && 
                <SelectInput<BruksklasseTommerTransport> 
                    allowedValues={BruksklasserTommerTransport}
                    label="Bruksklase tømmertransport" 
                    value={routeSettings.bruksklasseTommerTransport}
                    onChange={(value:BruksklasseTommerTransport) => {setRouteSettings({...routeSettings, bruksklasseTommerTransport: value})}}
                />
            }
        </>
    )
}